export default {"src":"/_next/static/media/mind.9c33bb18.svg","height":445,"width":600};